import React from 'react';
import {
  IconDashboard, IconOrders, IconUsers, IconShop,
  IconDelivery, IconMap, IconChart, IconLogout, IconBell, IconSettings
} from './Icons';

const navItems = [
  { section: 'मुख्य | Main' },
  { id: 'dashboard', label: 'डॅशबोर्ड | Dashboard', Icon: IconDashboard },
  { id: 'orders', label: 'ऑर्डर्स | Orders', Icon: IconOrders },
  { id: 'tracking', label: 'Live Tracking', Icon: IconMap },
  { section: 'व्यवस्थापन | Manage' },
  { id: 'users', label: 'कस्टमर्स | Customers', Icon: IconUsers },
  { id: 'shops', label: 'दुकाने | Shops', Icon: IconShop },
  { id: 'delivery', label: 'डिलिव्हरी बॉय', Icon: IconDelivery },
  { section: 'आर्थिक व मार्केटिंग | Finance & Marketing' },
  { id: 'expenses', label: '💰 खर्च व नफा (Expenses)', Icon: IconChart },
  { id: 'payouts', label: '💳 पेआऊट्स (Payouts)', Icon: IconChart },
  { id: 'coupons', label: '🎟️ कूपन कोड्स (Coupons)', Icon: IconSettings },
  { id: 'banners', label: '🖼️ अ‍ॅप बॅनर्स (Banners)', Icon: IconShop },
  { section: 'अहवाल व सूचना | Reports & Help' },
  { id: 'disputes', label: '⭐ तक्रार निवारण (Disputes)', Icon: IconBell },
  { id: 'notifications', label: 'सूचना | Notifications', Icon: IconBell },
  { id: 'reports', label: 'कमाई अहवाल', Icon: IconChart },
  { id: 'settings', label: 'सेटिंग्ज | Settings', Icon: IconSettings },
  { id: 'testCheckout', label: 'टेस्ट पेमेंट | Test Payment', Icon: IconChart },
];

export default function Sidebar({ activePage, setActivePage, logout, activeOrdersCount = 0 }) {
  return (
    <aside className="sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10,
            background: 'linear-gradient(135deg, var(--primary), var(--accent))',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 20, flexShrink: 0
          }}>🛺</div>
          <div>
            <div className="app-name">Smart Sangola</div>
            <div className="app-tag">Tumcha Local Super App</div>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {navItems.map((item, i) => {
          if (item.section) {
            return (
              <div key={i} className="nav-section-title">{item.section}</div>
            );
          }
          const { id, label, Icon } = item;
          const displayBadge = id === 'orders' ? (activeOrdersCount > 0 ? activeOrdersCount.toString() : null) : item.badge;
          return (
            <div
              key={id}
              className={`nav-item ${activePage === id ? 'active' : ''}`}
              onClick={() => setActivePage(id)}
            >
              <Icon size={17} className="nav-icon" />
              <span style={{ flex: 1 }}>{label}</span>
              {displayBadge && <span className="nav-badge">{displayBadge}</span>}
            </div>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="sidebar-footer">
        <div className="admin-info">
          <div className="admin-avatar">A</div>
          <div style={{ flex: 1 }}>
            <div className="admin-name">Admin</div>
            <div className="admin-role">Sangola HQ</div>
          </div>
          <button
            onClick={logout}
            title="Logout"
            style={{
              background: 'transparent', border: 'none', cursor: 'pointer',
              color: 'var(--text-muted)', padding: 4, borderRadius: 6,
              transition: 'color 0.2s'
            }}
            onMouseEnter={e => e.target.style.color = 'var(--danger)'}
            onMouseLeave={e => e.target.style.color = 'var(--text-muted)'}
          >
            <IconLogout size={16} />
          </button>
        </div>
      </div>
    </aside>
  );
}
